import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../core/store/store";
import { EmailFormValues, emailValidationSchema } from "../../../auth/presentation/interfaces/EmailFormInterface";
import { onSendOtp } from "../../../auth/presentation/store/auth/AuthThunk";
import { ContainerModal } from "../components/ContainerModal";
import { CustomButton } from "../../../../core/components/CustomButton";
import { CustomInput } from "../../../../core/components/CustomInput";
import { useAlert } from "../../../../core/hooks/useAlert";

interface VerificationProps {
	isOpen: boolean;
	onRequestClose: () => void;
	onContinue: (value: string) => void;
	type: string;
}

const initialEmailValues: EmailFormValues = { email: "" };

export const VerificationModal: React.FC<VerificationProps> = ({ isOpen, onRequestClose, onContinue, type }) => {
	const dispatch: AppDispatch = useDispatch();
	const { isLoading } = useSelector((state: RootState) => state.auth);
	const { showAlert } = useAlert();

	const handleSubmit = async (values: EmailFormValues, { setSubmitting, resetForm }: FormikHelpers<EmailFormValues>) => {
		const result = await dispatch(
			onSendOtp({
				email: values.email,
				type: type,
			})
		);
		if (onSendOtp.fulfilled.match(result)) {
			onContinue(values.email);
			resetForm();
		} else {
			showAlert({
				message: result.error.message || "Could not send the verification code right now.",
				type: "error",
			});
		}
		setSubmitting(false);
	};

	return (
		<Formik
			initialValues={initialEmailValues}
			validationSchema={emailValidationSchema}
			validateOnBlur
			validateOnChange={false}
			onSubmit={handleSubmit}
		>
			{({ handleChange, handleBlur }) => (
				<ContainerModal
					isOpen={isOpen}
					onRequestClose={onRequestClose}
					title="Enter your email address"
					subtitle="We will send you a verification code on your email address."
				>
					<Form>
						<Field
							as={CustomInput}
							name="email"
							hintText="Enter email address"
							label="Email Address"
							type="email"
							className="form-control"
							onChange={handleChange}
							onBlur={handleBlur}
							required
						/>
						<ErrorMessage
							name="email"
							component="div"
							className="text-red-500"
						/>
						<CustomButton
							type="submit"
							className="mt-4 sm:mt-10 sm:mb-24"
							loading={isLoading}
						>
							Continue
						</CustomButton>
					</Form>
				</ContainerModal>
			)}
		</Formik>
	);
};
